module.exports = __webpack_public_path__ + "static/media/criminal.566dbd76.svg";